import React from "react";

import {
    Box,
    Breadcrumbs,
    Button,
    CssBaseline,
    Divider,
    Grid,
    Link,
    Stack,
    ThemeProvider,
    Typography
} from "@mui/material";
import { lightTheme } from "./Themes";
import { Portada } from "./components/Portada";
import { TopBar } from "./components/TopBar";
import { NavigationMenu } from "./components/NavigationMenu";
import { BottomBanner } from "./components/BottomBanner";
import { Skyline } from "./components/Skyline";
import { PictureAsPdf } from "@mui/icons-material";

import platino_ribbon from './images/patrocinadores/ribbons/platino.png'
import oro_ribbon from './images/patrocinadores/ribbons/oro.png'
import plata_ribbon from './images/patrocinadores/ribbons/plata.png'
import bronce_ribbon from './images/patrocinadores/ribbons/bronce.png'
import sponsor_ribbon from './images/patrocinadores/ribbons/sponsor.png'
import colaborador_ribbon from './images/patrocinadores/ribbons/colaborador.png'

import dossier_es from './documents/2025-08-05_ursi_2026_dossier_patrocinio_castellano.pdf'
import dossier_en from './documents/2025-08-05_ursi_2026_dossier_patrocinio_ingles.pdf'


import { globalMaxWidth } from "./GlobalConfigs";
import {
    patrocinadoresBronce,
    patrocinadoresOro,
    patrocinadoresPlata,
    patrocinadoresPlatino,
    patrocinadoresSponsor,
    patrocinadoresColaborador
} from "./PatrocinadoresImageList";

function Downloads() {
    return <Stack margin={4} spacing={4}>
        <Typography variant='h6' color='primary'>
            Puede descargar el dossier de patrocinio de los siguientes enlaces:
        </Typography>
        <Stack direction='row' alignItems='center' spacing={4}>
            <Button variant='text' href={dossier_es}>
                <Stack alignItems='center' spacing={2}>
                    <PictureAsPdf color='white' fontSize='large' />
                    <Typography>
                        Dossier Patrocinadores
                    </Typography>
                </Stack>
            </Button>
            <Button variant='text' href={dossier_en}>
                <Stack alignItems='center' spacing={2}>
                    <PictureAsPdf color='white' fontSize='large' />
                    <Typography>
                        Sponsorship Dossier
                    </Typography>
                </Stack>
            </Button>
        </Stack>
    </Stack>;
}

function PatrocinadorImg({ img, href, multiplier = 1.0 }) {
    const baseSizeMd = 155;
    const baseSizeSm = 75;

    const width = {
        md: `${baseSizeMd * multiplier}px`,
        sm: `${baseSizeSm * multiplier}px`,
        xs: `${baseSizeSm * multiplier}px`
    };
    const height = {
        md: `${baseSizeMd}px`, // Keeping original height behavior
        sm: `${baseSizeSm}px`,
        xs: `${baseSizeSm}px`
    };

    return (
        <Grid item size={2}>
            <Button margin={1} href={href}
                sx={{
                    height: height,
                    width: width,
                    backgroundImage: `url(${img})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center'
                }}
            >
            </Button>
        </Grid>
    );
}

const Ribbon = ({ ribbonImage }) => {
    return (
        <Box id='ribbon' sx={{
            position: 'absolute',
            width: { lg: '130px', md: '130px', sm: '85px', xs: '85px' },
            height: { lg: '130px', md: '130px', sm: '85px', xs: '85px' },
            backgroundImage: `url(${ribbonImage})`,
            backgroundSize: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top-left',
            zIndex: 100
        }}>
        </Box>
    );
};

function Patrocinadores({ patrocinadoresList, text, ribbonImage }) {

    return (
        <Box margin={0} padding={3} sx={{
            maxWidth: globalMaxWidth,
            width: 1
        }}>
            <Ribbon ribbonImage={ribbonImage} />
            <Box container component={Grid}
                justifyContent='space-evenly'
                margin={1}
                spacing={1}
                alignItems='center'
                sx={{
                    boxShadow: 5,
                    borderRadius: 7,
                    // minWidth: '80%',
                    minHeight: 200
                }}
            >
                {patrocinadoresList.map((patrocinador) => (
                    <PatrocinadorImg img={patrocinador[0]} href={patrocinador[1]} multiplier={patrocinador[2]} />
                ))
                }
            </Box>
        </Box>
    );
}

function BreadcrumbSection() {
    return (
        <Breadcrumbs aria-label="breadcrumb" margin={2}>
            <Link underline="hover" color="inherit" href="/">
                Home
            </Link>
            <Typography sx={{ color: 'text.primary' }}>Patrocinadores</Typography>
        </Breadcrumbs>
    );
}

function PatrocinadoresPage() {
    return (
        <ThemeProvider theme={lightTheme}>
            <div className="App">
                <CssBaseline />
                <Stack alignItems='center' >
                    <TopBar />
                    <NavigationMenu />
                    <Portada with_buttons={false} construction_text={false} />
                    <BreadcrumbSection />
                    <Downloads />
                    <Divider orientation='horizontal' sx={{
                        width: '80%'
                    }} />
                    <Stack alignItems='center' spacing={0} margin={4} sx={{
                        width: "80%"
                    }}>
                        <Patrocinadores patrocinadoresList={patrocinadoresPlatino} ribbonImage={platino_ribbon} text='PLATINO' />
                        <Patrocinadores patrocinadoresList={patrocinadoresOro} ribbonImage={oro_ribbon} text='ORO' />
                        <Patrocinadores patrocinadoresList={patrocinadoresPlata} ribbonImage={plata_ribbon} text='PLATA' />
                        <Patrocinadores patrocinadoresList={patrocinadoresBronce} ribbonImage={bronce_ribbon} text='BRONCE' />
                        <Patrocinadores patrocinadoresList={patrocinadoresSponsor} ribbonImage={sponsor_ribbon} text='SPONSOR' />
                        <Patrocinadores patrocinadoresList={patrocinadoresColaborador} ribbonImage={colaborador_ribbon} text='COLABORADOR' />
                    </Stack>
                    <Skyline />
                    <BottomBanner />
                </Stack>
            </div>
        </ThemeProvider>
    )
}

export default PatrocinadoresPage;
